import { ADDRESS_REQUEST, LOADING, SUCCESS, NOT_ASKED, FAILURE } from './constants';

/**
 * address call actions
 * **/

export function addressRequest(apexAccountId) {
  return {
    type: ADDRESS_REQUEST,
    apexAccountId,
  };
}

/**
 * Used by the saga to set the status.
 */
export function notAsked() {
  return {
    type: NOT_ASKED,
  };
}

/**
 * Used by the saga to set the status and store params.
 */
export function loading(apexAccountId) {
  return {
    type: LOADING,
    apexAccountId,
  };
}

export function success(result) {
  return {
    type: SUCCESS,
    result,
  };
}

/**
 * Used by the saga to set the status and store the error.
 */
export function failure(error) {
  return {
    type: FAILURE,
    error,
  };
}



// WEBPACK FOOTER //
// ./src/services/addressPreview/actions.js